import {
  ChannelList,
  FilamentList,
  MessageTemplateList,
  PackagingKitList,
  PrinterList,
  SupplyList,
} from '@deizi/shared';
import { useQuery } from '@tanstack/react-query';
import { api } from './api';

/** Catalog lists used across screens (same keys as their own pages, so edits refresh them). */
export const usePrinters = () =>
  useQuery({ queryKey: ['printers'], queryFn: () => api.get('/printers?limit=200', PrinterList) });

export const useFilaments = () =>
  useQuery({
    queryKey: ['filaments'],
    queryFn: () => api.get('/filaments?limit=200', FilamentList),
  });

export const useChannels = () =>
  useQuery({ queryKey: ['channels'], queryFn: () => api.get('/channels?limit=200', ChannelList) });

export const useKits = () =>
  useQuery({
    queryKey: ['packaging-kits'],
    queryFn: () => api.get('/packaging-kits?limit=200', PackagingKitList),
  });

export const useSupplies = () =>
  useQuery({ queryKey: ['supplies'], queryFn: () => api.get('/supplies?limit=200', SupplyList) });

export const useTemplates = () =>
  useQuery({
    queryKey: ['message-templates'],
    queryFn: () => api.get('/message-templates', MessageTemplateList),
  });
